import type { IEnv } from './env';
import { injectENV } from './env';

const KEY_ALL_MODELOVERRIDES = 'REACT_APP_MODELOVERRIDES';

type ModelOverrides<T> = Record<string, ((obj: T) => T) | undefined>;

export function getProjectOverrides<T>(name: string, obj: T, env: IEnv = injectENV()): T {
    const allOverrides = env.getValueWithDefault<ModelOverrides<T>>(KEY_ALL_MODELOVERRIDES, {});
    const overrideMapper = allOverrides[name];
    const result = overrideMapper ? overrideMapper(obj) : obj;
    return result;
}
